import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS, IMAGES } from "../data/content";

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} id="manifesto" data-testid="manifesto-section" className="noise relative bg-[#0A0A0A] py-28 md:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">The Novaphi Manifesto</p>
          <h2 className="font-serif-e text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-[#F9F9F6] max-w-3xl">
            Where every detail matters.
          </h2>
        </Reveal>
        <div className="mt-20 grid grid-cols-12 gap-y-20 md:gap-x-10">
          <div className="col-span-12 lg:col-span-8 space-y-24">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.num} delay={i * 0.1} className={`relative ${i === 1 ? "lg:ml-24" : ""} ${i === 2 ? "lg:ml-10" : ""}`}>
                <span data-testid={`chapter-number-${c.num}`} className="font-serif-e absolute -top-14 -left-2 text-[8rem] md:text-[11rem] leading-none text-[#D4AF37]/10 select-none pointer-events-none">
                  {c.num}
                </span>
                <div className="relative">
                  <h3 className="font-serif-e text-3xl md:text-4xl text-[#D4AF37] italic">{c.title}</h3>
                  <p data-testid={`chapter-quote-${c.num}`} className="font-serif-e text-2xl md:text-3xl text-[#F9F9F6] mt-4 leading-snug max-w-xl">
                    “{c.quote}”
                  </p>
                  <p className="text-[#F9F9F6]/60 text-base leading-relaxed mt-5 max-w-lg">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="col-span-12 lg:col-span-4">
            <Reveal delay={0.2} className="lg:sticky lg:top-32">
              <div className="relative aspect-[3/4] overflow-hidden vignette border border-[#F9F9F6]/10">
                <motion.img src={IMAGES.buffetGold} alt="Novaphi gold buffet spread" data-testid="manifesto-image"
                            style={{ y: imgY }} className="w-full h-[118%] object-cover scale-105" />
              </div>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#F9F9F6]/40 mt-4">Buffet catering — gold standard</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
